const getCurrentTime = () => Date.now();
export default getCurrentTime;